.an{flex:1;}